class ProductTabs extends HTMLElement {
  constructor() {
    super();

    this.headings = this.querySelectorAll('.tabs__heading')
    this.tabs = this.querySelectorAll('.tabs__content__item')

    this.headings.forEach((item, index) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();

        this.querySelector('.tabs__heading.is-active').classList.remove('is-active')
        item.classList.add('is-active')
        this.switchTab(index)
      });
    })
  }

  switchTab(index) {
    this.querySelector('.tabs__content__item.is-active')?.classList.remove('is-active')
    if (index + 1 <= this.tabs.length) this.tabs[index].classList.add('is-active')
  }
}

customElements.define('product-tabs', ProductTabs);

class ProductTabsMobile extends HTMLElement {
  constructor() {
    super();

    this.headers = this.querySelectorAll('.mobile-tabs__header')
    this.headers.forEach(header => {
      header.addEventListener('click', e => {
        this.toggleTab(e)
      })
      header.addEventListener('keydown', e => {
        if (e.key == 'Enter' || e.key == 'Space') {
          e.preventDefault()
          this.toggleTab(e)
        }
      })
    })
  }

  toggleTab(e) {
    const clickedHeader = e.target.closest('.mobile-tabs__header')
    const targetContent = clickedHeader.parentNode.querySelector('.mobile-tabs__content')

    window.animationSlideToggle(targetContent, 150)
    clickedHeader.parentNode.classList.toggle('is-active')
  }

}

customElements.define('product-tabs-mobile', ProductTabsMobile);